"use client";
import { useEffect } from "react";

const KEY = "recently_viewed";
const MAX = 12;
export function useRecentlyViewed(productId?: number) {
  useEffect(() => {
    if (!productId) return;
    const raw = localStorage.getItem(KEY);
    let arr: number[] = [];
    try {
      arr = JSON.parse(raw || "[]");
    } catch {
      arr = [];
    }
    arr = [productId, ...arr.filter((id) => id !== productId)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(arr));
  }, [productId]);
  return null;
}
export function getRecentlyViewedIds(): number[] {
  if (typeof window === "undefined") return [];
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]") as number[];
  } catch {
    return [];
  }
}
